import { render } from "./WaiterOrder.vue?vue&type=template&id=d21a56f4"
import script from "./WaiterOrder.vue?vue&type=script&lang=js"
export * from "./WaiterOrder.vue?vue&type=script&lang=js"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__